import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ScriptToggleComponent } from '../script-toggle/script-toggle.component';

@Component({
  selector: 'lv-walk-step-biometrics',
  templateUrl: 'walk-step-biometrics.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, ScriptToggleComponent]
})
export class WalkStepBiometricsComponent {}
